export class StatisticStates {
  all: number;
  done: number;
  draft: number;
  errors: number;
  deleted: number;
  imported: number;
  deleted_done: number;
  pending_sync: number;
  pending_accounting: number;

  constructor(all: number, done: number, draft: number, errors: number, deleted: number, imported: number, deleted_done: number, pending_sync: number, pending_accounting: number) {
    this.all = all;
    this.done = done;
    this.draft = draft;
    this.errors = errors;
    this.deleted = deleted;
    this.imported = imported;
    this.deleted_done = deleted_done;
    this.pending_sync = pending_sync;
    this.pending_accounting = pending_accounting;
  }

  clone(): StatisticStates {
    return new StatisticStates(this.all, this.done, this.draft, this.errors, this.deleted, this.imported, this.deleted_done, this.pending_sync, this.pending_accounting);
  }
}

export class BankStatisticLine {
  company_id: number;
  company_name: string;
  deleted: boolean;
  states: StatisticStates  

  constructor(company_id: number, company_name: string, deleted: boolean, states: StatisticStates) {
      this.company_id = company_id;
      this.company_name = company_name;
      this.deleted = deleted;
      this.states = states;
  }

  clone(): BankStatisticLine {
      return new BankStatisticLine(this.company_id, this.company_name, this.deleted, this.states.clone());
  }
}
